import styled from 'styled-components';

export const PickupChannelsWrapper = styled.div`
    height: 1.5rem;
`;
